/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Container,
  Grid,
  Snackbar,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Alert from '@material-ui/lab/Alert';

import moment from 'moment';
import MaterialTable from 'material-table';
import uiActions from '../../../../redux/actions/uiActions';
import userActions from '../../../../redux/actions/userActions';

import StudentExportButtons from './StudentExportButtons';
import companyServices from '../../../../redux/services/companyServices';
import { Loading, min2Time, sec2time } from '../../../../helpers/utils';

const useStyles = makeStyles(() => ({
  root: {
    marginBottom: '10em',
    marginTop: '5em',
    width: '100%',
  },
  headerWrap: {
    marginTop: '1rem',
  },
  stickyHead: {
    position: 'sticky',
    top: 0,
    background: '#fafafa',
    zIndex: 1,
  },
}));

const Exports = ({
  userData,
  changePageTitle,
  group,
  currentGroup,
}) => {
  const classes = useStyles();

  const [loading, setLoading] = useState(true);
  const [errorSnackBar, setErrorSnackBar] = useState(null);
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    changePageTitle('Results | Official results');
  }, [changePageTitle]);

  const findStudentExportData = (arr, objectives, exportItem) => {
    let studentObj = false;
    arr.forEach((studentResultItem) => {
      if (studentResultItem._id === userData._id) {
        // Objet étudiant avec tous les résultats + objectifs + infos du semestre
        studentObj = {
          ...studentResultItem,
          ...objectives,
          semester: exportItem.semester,
          catchUp: exportItem.catchUp || false, // Session 1 ou 2 (rattrapage)
          exportDate: exportItem.created_at, // Date de l'export, important pour prévenir les plaintes
        };
      }
    });
    return studentObj;
  };

  const getExportsData = async () => {
    setLoading(true);
    const res = await companyServices.getExportsByCompany(userData.company._id);
    if (res && res.length > 0) {
      const tempExportsArr = [];
      // Récupération des exports du bon semestre
      res.forEach((exportItem) => {
        if (exportItem.semester === group.semester) {
          tempExportsArr.push(exportItem);
        }
      });
      // traitement des exports pour voir si l'étudiant est dedans, si étudiant trouvé, ses résultats sont ajoutés au tableau temporaire avec les objectifs à atteindre
      if (tempExportsArr && tempExportsArr.length > 0) {
        const tempArrResultsStudent = [];
        tempExportsArr.forEach((exportItem) => {
          exportItem.results.forEach((resultObj) => {
            // to counter when students are in no track and rattrapage both (time issues, possible with new LRS)
            const studentObjNoTrack = findStudentExportData(resultObj.csvnotrack.data, resultObj.csvnotrack.target, exportItem);
            const studentObjRattrapage = findStudentExportData(resultObj.csvrattrapage.data, resultObj.csvrattrapage.target, exportItem);
            const studentObjSuccess = findStudentExportData(resultObj.csvsuccess.data, resultObj.csvsuccess.target, exportItem);
            if (studentObjNoTrack && !studentObjRattrapage && !studentObjSuccess) {
              tempArrResultsStudent.push(studentObjNoTrack);
            } else if (studentObjRattrapage) {
              tempArrResultsStudent.push(studentObjRattrapage);
            } else if (studentObjSuccess) {
              tempArrResultsStudent.push(studentObjSuccess);
            }
          });
        });
        setExportData(tempArrResultsStudent);
        setLoading(false);
      } else {
        setExportData([]);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getExportsData();
  }, [userData.company._id, group, currentGroup]);

  return (
    <Container className={classes.root}>
      <Snackbar
        open={errorSnackBar !== null}
        onClose={() => { setErrorSnackBar(null); }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          severity={errorSnackBar !== null ? errorSnackBar.severity : 'info'}
          variant="filled"
          onClose={() => { setErrorSnackBar(null); }}
        >
          {`Error ${errorSnackBar?.code}: ${errorSnackBar?.message}`}
        </Alert>
      </Snackbar>

      {loading === false
        ? (
          <Box>
            {exportData.length === 0 ? (
              <Grid item xs={12}>
                <Alert severity="info">
                  Aucun export effectué pour ce semestre.
                </Alert>
              </Grid>
            ) : (
              <MaterialTable
                title="Exports du semestre"
                columns={[
                  {
                    title: 'Nom',
                    field: 'name',
                  },
                  {
                    title: 'Prénom',
                    field: 'firstname',
                  },
                  {
                    title: 'Taux de réussite (quiz)',
                    field: 'percent',
                    render: ({ percent }) => (
                      <Typography
                        variant="body2"
                        color={
                          percent >= group.elearning.elearningTarget
                            ? 'primary'
                            : 'secondary'
                        }
                      >
                        {`${percent}% / ${group.elearning.elearningTarget}%`}
                      </Typography>
                    ),
                  },
                  {
                    title: 'Taux de progression (unités)',
                    field: 'unitsPercent',
                    render: ({ unitsPercent }) => (
                      <Typography
                        variant="body2"
                        color={
                          unitsPercent >= group.elearning.elearningAttempts
                            ? 'primary'
                            : 'secondary'
                        }
                      >
                        {`${unitsPercent}% / ${group.elearning.elearningAttempts}%`}
                      </Typography>
                    ),
                  },
                  {
                    title: 'Temps de connexion',
                    field: 'time',
                    render: ({ time }) => (
                      <Typography
                        variant="body2"
                        color={
                          time >= (((group.elearning.elearningDuration / 100) * group.elearning.elearningDurationTarget) * 60)
                            ? 'primary'
                            : 'secondary'
                        }
                      >
                        {`${sec2time(time)} / ${min2Time((group.elearning.elearningDuration / 100) * group.elearning.elearningDurationTarget)}`}
                      </Typography>

                    ),
                  },
                  {
                    title: 'Date de l\'export',
                    field: 'exportDate',
                    render: ({ exportDate }) => <Typography variant="body2">{moment(new Date(exportDate)).format('DD/MM/YYYY à HH:mm')}</Typography>,
                  },
                  {
                    title: 'Session',
                    field: 'catchUp',
                    render: ({ catchUp }) => <Typography variant="body2">{`Session ${catchUp ? '2' : '1'}`}</Typography>,
                  },
                  {
                    title: 'Exports',
                    field: 'unitsPercent',
                    render: (rowData) => (
                      <StudentExportButtons
                        exportData={rowData}
                        semesterName={group.name}
                        group={group}
                      />
                    ),
                  },
                ]}
                data={exportData}
                style={{
                  width: '100%',
                }}
                options={{
                  search: false,
                }}
              />
            )}
          </Box>
        )
        : <Loading />}
    </Container>
  );
};

Exports.propTypes = {
  userData: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  changePageTitle: PropTypes.func.isRequired,
};

const mapState = (state) => {
  const { group } = state;
  const { userData } = state.user;
  const { currentGroup } = state.ui;
  return {
    group: group.data[currentGroup],
    userData,
    currentGroup,
  };
};

const actionCreators = {
  changePageTitle: uiActions.changePageTitle,
  logout: userActions.logout,
};

export default connect(mapState, actionCreators)(Exports);
